/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
// import { BasestationConnectionProps } from './types/BasestationConnectionProps';

const ViewBasestationConnection = ({ view }) => {
  return (
    <div id="view_access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title my-2">Details</h4>
            <button type="button" className="mr-2 close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div className="modal-body detail p-0">
            <div className="row">
              <div className="col-lg-12 d-flex">
                <div className="col-lg-5 detail-label1">
                  <label className="mt-1">Site Name</label>
                  <label className="mt-1">Network</label>
                  <label className="mt-1">SSID</label>
                </div>
                <div className="col-lg-7 detail-result1 item-font">
                  <p className="mt-4 mb-2">{view.site_name}</p>
                  <p className="mb-2">{view.network}</p>
                  <p className="mb-2">{view.ssid}</p>
                </div>
              </div>
              <div className="col-lg-12 d-flex">
                <div className="col-lg-5 detail-label3">
                  <label>IP Address</label>
                  <label className="mt-1">Product Name</label>
                  <label className="mt-1">Frequency</label>
                </div>
                <div className="col-lg-7 detail-result2 item-font">
                  <p className="mt-4 mb-2">{view.ip_address}</p>
                  <p className="mb-2">{view.product_name}</p>
                  <p className="mb-2">{view.frequency}</p>
                </div>
              </div>

              <div className="col-lg-12 d-flex">
                <div className="col-lg-5 detail-label1">
                  <label className="mt-1">Stations</label>
                  <label className="mt-1">Host</label>
                  <label className="mt-1">Active</label>
                </div>
                <div className="col-lg-7 detail-result1 item-font">
                  <p className="mt-4 mb-2">{view.stations}</p>
                  <p className="mb-2">{view.host}</p>
                  <p className="mb-2">{view.active}</p>
                </div>
              </div>
              <div className="col-lg-12 d-flex">
                <div className="col-lg-5 detail-label3">
                  <label>Public IP</label>
                  <label className="mt-1">Number of Public IP</label>
                </div>
                <div className="col-lg-7 detail-result2 item-font">
                  <p className="mt-4 mb-2">{view.public_ip}</p>
                  <p className="mb-2">{view.number_of_public_ip}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBasestationConnection;
